import { Tabs } from 'antd';
import classNames from 'classnames';
import React from 'react';
import type { IPropsCustomTabs } from './types';
import style from './style.module.scss';

const CustomTabs = ({
  mode = 'horizontal',
  size = 'large',
  className,
  defaultActiveKey,
  activeKey,
  onChange,
  onTabClick,
  items,
  tabTitleClassName,
  tabBarExtraContent,
}: IPropsCustomTabs): React.JSX.Element => (
  <Tabs
    rootClassName={classNames(
      'custom-tabs',
      style.customTabs,
      style[`customTabs--${size}`],
      `custom-tabs--${size}`,
      className,
    )}
    defaultActiveKey={defaultActiveKey}
    activeKey={activeKey}
    tabPosition={mode === 'horizontal' ? 'top' : 'left'}
    onChange={onChange}
    onTabClick={onTabClick}
    items={items.map((item) => {
      const isActive = item.key === activeKey;
      const quantity = item.quantity ?? 0;
      return {
        label: (
          <div
            id={item.id}
            className={classNames(
              style.tabTitle,
              isActive ? style.tabTitleActive : undefined,
              tabTitleClassName,
            )}
            key={`tab-${item.key}`}
          >
            {isActive ? item?.activeIcon : item?.icon}
            <span className={classNames(item?.icon ? style.ml10 : undefined)}>{item.label}</span>
            {quantity > 0 && (
              <span className={classNames(style.tabQuantity, item.quantityClassName)}>
                {quantity > 100 ? '99+' : quantity}
              </span>
            )}
          </div>
        ),
        key: item.key,
        children: item.children,
        disabled: item.disabled,
      };
    })}
    tabBarExtraContent={tabBarExtraContent}
  />
);

export default CustomTabs;
